// extracted by mini-css-extract-plugin
export default {"background":"DashboardResources_background__4QFKY","resourceBox":"DashboardResources_resourceBox__-uLdR"};